import { render, staticRenderFns } from "./GroupManagementRegistrationPopup.vue?vue&type=template&id=474b1540&scoped=true&"
import script from "./GroupManagementRegistrationPopup.vue?vue&type=script&lang=js&"
export * from "./GroupManagementRegistrationPopup.vue?vue&type=script&lang=js&"
import style0 from "./GroupManagementRegistrationPopup.vue?vue&type=style&index=0&id=474b1540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474b1540",
  null
  
)

export default component.exports